import AppPage from "layouts/AppPage";
import LinkCard from "components/Card/LinkCard";
import { Wrap, WrapItem } from "@chakra-ui/react";
import { GoPersonFill } from "react-icons/go";
import { HiCalendarDays, HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { PiChartLineUp, PiDatabase } from "react-icons/pi";
import { BsBuildingGear } from "react-icons/bs";
import { MdInput, MdPalette } from "react-icons/md";
import { FiToggleRight } from "react-icons/fi";
import { TbDatabaseExport } from "react-icons/tb";
import { VscOutput } from "react-icons/vsc";
import { BiError } from "react-icons/bi";
import { ADMIN_ROUTES } from "definitions/constants/routeConstants";
import useNavbar from "hooks/useNavbar";
import { useEffect } from "react";

const ADMIN_LINKS = [
  {
    url: ADMIN_ROUTES.blazer,
    label: "Blazer",
    description: "Business intelligence",
    icon: PiChartLineUp,
  },
  {
    url: ADMIN_ROUTES.pgHero,
    label: "PgHero",
    description: "Database Performance",
    icon: PiDatabase,
  },
  {
    url: ADMIN_ROUTES.users.index,
    label: "Users",
    description: "Manage users",
    icon: GoPersonFill,
  },
  {
    url: ADMIN_ROUTES.companies.index,
    label: "Companies",
    description: "Manage companies",
    icon: HiOutlineBuildingOffice2,
  },
  {
    url: ADMIN_ROUTES.designSystem,
    label: "Design System",
    description: "Browse components and tokens",
    icon: MdPalette,
  },
  {
    url: ADMIN_ROUTES.customInputs,
    label: "Custom Inputs",
    description: "FloatingField compound component examples",
    icon: MdInput,
  },
  {
    url: ADMIN_ROUTES.flipper,
    label: "Feature Flags",
    description: "Manage feature flags",
    icon: FiToggleRight,
  },
  {
    url: ADMIN_ROUTES.jobs,
    label: "Jobs",
    description: "Manage jobs",
    icon: BsBuildingGear,
  },
  {
    url: ADMIN_ROUTES.calendarTest,
    label: "Calendar Test",
    description: "Test calendar functionality",
    icon: HiCalendarDays,
  },
  {
    url: ADMIN_ROUTES.litestream,
    label: "Litestream",
    description: "Database backups and replication",
    icon: TbDatabaseExport,
  },
  {
    url: ADMIN_ROUTES.logs,
    label: "Logs",
    description: "Application logs",
    icon: VscOutput,
  },
  {
    url: ADMIN_ROUTES.errors,
    label: "Errors",
    description: "Error tracking and debugging",
    icon: BiError,
  },
];

export default function HubPage() {
  const { setPageTitle } = useNavbar();
  useEffect(() => {
    setPageTitle("Admin");
  }, [setPageTitle]);

  return (
    <AppPage>
      <Wrap width="100%" spacingX="4">
        {ADMIN_LINKS.map(({ url, description, label, icon }) => (
          <WrapItem key={url} height="209px">
            <LinkCard target={{ url, description }} label={label} icon={icon} />
          </WrapItem>
        ))}
      </Wrap>
    </AppPage>
  );
}
